<div class="header">
    <div id="logo">
        <img src="../../../assets/images/Bayer.png">
    </div>

    <div id="title">
        <p>PRO CARBONO CONECTA</p>
    </div>
</div>